import React, { useState, useRef, useEffect } from "react";
import { InputNumber } from "antd";
import styles from "./styles.module.scss";

interface IProps {
  value: number;
  onSave: (newValue: number) => Promise<void>;
}

const EditablePickSequence: React.FC<IProps> = ({ value, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [editing]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleSave = async () => {
    if (inputValue === value || inputValue == null) {
      setEditing(false);
      return;
    }
    setLoading(true);
    try {
      await onSave(inputValue);
    } finally {
      setLoading(false);
      setEditing(false);
    }
  };

  if (editing) {
    return (
      <InputNumber
        ref={inputRef}
        value={inputValue}
        min={1}
        size="small"
        className={styles.input}
        disabled={loading}
        onChange={(val) => setInputValue(val as number)}
        onPressEnter={handleSave}
        onBlur={handleSave}
      />
    );
  }

  return (
    <span className={styles.editable} onClick={() => setEditing(true)}>
      {value}
    </span>
  );
};

export default EditablePickSequence;
